import Vue from 'vue'

// Import Raven, Sentry's SDK
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'

// Import our local "config.js" file
import config from './config'

import App from './App.vue'
import router from './router'
import store from './store'
// import './rem'
import './registerServiceWorker'
import {
  Button, Checkbox, CheckboxGroup, Cell, CellGroup, Icon, Row, Col, Popup, Picker,
  Toast, Dialog, Lazyload, List, PullRefresh, DatetimePicker, Field, Swipe, SwipeItem,
  Loading
} from 'vant'
import errorImg from './components/assets/imgFail.png'

import VueVideoPlayer from 'vue-video-player' // 视频播放器
import 'video.js/dist/video-js.css'
import './utils/videoPanel.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

if (process.env.NODE_ENV === 'production') {

} else {
  // You may remove this once you are sure everything works fine
  console.debug('Not configuring Sentry, environment is', process.env.NODE_ENV)
}

// Here, import everything you need to setup you app
// 引入vant基础组件
Vue.use(Button)
Vue.use(Checkbox).use(CheckboxGroup)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Icon)
Vue.use(Row)
Vue.use(Col)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(Toast)
Vue.use(Dialog)
Vue.use(List)
Vue.use(PullRefresh)
Vue.use(DatetimePicker)
Vue.use(Field)
Vue.use(Loading)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Lazyload, {
  preLoad: 1.3,
  error: errorImg,
  attempt: 1
})

Vue.use(VueVideoPlayer)
Vue.use(VueAwesomeSwiper)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
